"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PageConfigurationsImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing PageConfigurations operations. */
var PageConfigurationsImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class PageConfigurations class.
   * @param client Reference to the service client
   */
  function PageConfigurationsImpl(client) {
    (0, _classCallCheck2["default"])(this, PageConfigurationsImpl);
    this.client = client;
  }
  /**
   * @param portalId
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(PageConfigurationsImpl, [{
    key: "getSearchPageConfiguration",
    value: function getSearchPageConfiguration(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getSearchPageConfigurationOperationSpec);
    }
    /**
     * @param portalId
     * @param options The options parameters.
     */

  }, {
    key: "getDocumentPageConfiguration",
    value: function getDocumentPageConfiguration(portalId, options) {
      var operationArguments = {
        portalId: portalId,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDocumentPageConfigurationOperationSpec);
    }
  }]);
  return PageConfigurationsImpl;
}(); // Operation Specifications


exports.PageConfigurationsImpl = PageConfigurationsImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getSearchPageConfigurationOperationSpec = {
  path: "/api/Portals({portalId})/PageConfigurations/Soeg",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.SearchPageConfigurationModel
    }
  },
  queryParameters: [Parameters.searchPreviewName],
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getDocumentPageConfigurationOperationSpec = {
  path: "/api/Portals({portalId})/PageConfigurations/Document",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.DocumentPageConfigurationModel
    }
  },
  urlParameters: [Parameters.$host, Parameters.portalId],
  headerParameters: [Parameters.accept],
  serializer: serializer
};